import { render, staticRenderFns } from "./payment-type-selector-notice.vue?vue&type=template&id=632d11f2"
import script from "./payment-type-selector-notice.vue?vue&type=script&lang=js"
export * from "./payment-type-selector-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports